var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.747a2.25 2.25 0 104.501.005A2.25 2.25 0 0021 18.747v0zM4.5 18.747a2.25 2.25 0 104.5.006 2.25 2.25 0 00-4.5-.006v0zM9 19.5h12",
    stroke: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.125 19.5h.366c.4 0 .784-.154 1.067-.428.283-.274.442-.645.442-1.032v-2.337a1.429 1.429 0 00-.323-.924 1.516 1.516 0 00-.852-.521l-3.521-.745a1.512 1.512 0 01-.695-.346l-3.481-3.037a1.556 1.556 0 00-1.006-.38H8.569a1.548 1.548 0 00-.771.202 1.483 1.483 0 00-.557.555L5.822 12.98a1.51 1.51 0 01-.754.645l-1.127.443a1.5 1.5 0 00-.685.54 1.427 1.427 0 00-.256.818v2.604c0 .387.159.759.442 1.032.283.274.667.428 1.067.428h.366",
    stroke: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.086a90ab.svg";
export { ForwardRef as ReactComponent };